import type { TranslationMessages } from 'react-admin'

const messages: TranslationMessages = {
  ra: {
    action: {
      delete: 'Borrar',
      show: 'Mostrar',
      list: 'Listar',
      save: 'Guardar',
      create: 'Crear',
      edit: 'Editar',
      sort: 'Ordenar',
      cancel: 'Cancelar',
      undo: 'Deshacer',
      refresh: 'Refrescar',
      add: 'Agregar',
      remove: 'Remover',
      add_filter: 'Agregar filtro',
      remove_filter: 'Remover este filtro',
      back: 'Regresar',
      bulk_actions: '%{smart_count} seleccionado',
      export: 'Exportar',
      clear_array_input: 'Limpiar lista',
      clear_input_value: 'Limpiar valor',
      clone: 'Clonar',
      confirm: 'Confirmar',
      create_item: 'Crear elemento',
      remove_all_filters: 'Remover todos los filtros',
      search: 'Buscar',
      select_all: 'Seleccionar todo',
      select_row: 'Seleccionar fila',
      unselect: 'Deseleccionar',
      expand: 'Expandir',
      close: 'Cerrar',
      open_menu: 'Abrir menú',
      close_menu: 'Cerrar menú',
      update: 'Actualizar',
      move_up: 'Mover arriba',
      move_down: 'Mover abajo',
      open: 'Abrir',
      toggle_theme: 'Cambiar tema',
      select_columns: 'Seleccionar columnas',
      update_application: 'Actualizar aplicación',
      select_all_button: 'Seleccionar todo',
    },
    boolean: {
      true: 'Si',
      false: 'No',
      null: 'Nulo',
    },
    page: {
      list: 'Lista de %{name}',
      edit: '%{name} #%{id}',
      show: '%{name} #%{id}',
      create: 'Crear %{name}',
      dashboard: 'Dashboard',
      not_found: 'No encontrado',
      loading: 'Cargando',
      error: 'Ha ocurrido un error',
      empty: 'Sin contenido',
      invite: 'Invitar',
      access_denied: 'Acceso denegado',
      authentication_error: 'Error de autenticación',
    },
    input: {
      file: {
        upload_several: 'Arrastra algunos archivos para empezar la subida, o presiona aqui para seleccionarlos.',
        upload_single: 'Arrastra un archivo para empezar la subida, or presiona aqui para seleccionarlo.',
      },
      image: {
        upload_several: 'Arrastra algunas images para empezar la subida, or persiona aqui para seleccionar una.',
        upload_single: 'Arrastra una imagen aqui para empezar la subida, or presiona aqui para seleccionarla.',
      },
      references: {
        all_missing: 'No se encontro ninguna referencia.',
        many_missing: 'Al menos una de las referencias asociadas parece ya no estar disponible.',
        single_missing: 'La referencia asociada parece ya no estar disponible.',
      },
      password: {
        toggle_visible: 'Ocultar contraseña',
        toggle_hidden: 'Mostrar contraseña',
      },
    },
    message: {
      yes: 'Si',
      no: 'No',
      are_you_sure: 'Estas seguro?',
      about: 'Acerca de',
      not_found: 'Either you typed a wrong URL, or you followed a bad link.',
      loading: 'La pagina esta cargando, espera un momento por favor',
      invalid_form: 'El formulario no es valido. Por favor busca por errores',
      delete_title: 'Borrar %{name} #%{id}',
      delete_content: 'Estas seguro que quieres borrar este elemento?',
      bulk_delete_title: 'Borrar %{name} |||| Borrar %{smart_count} %{name} elementos',
      bulk_delete_content:
        'Estas seguro de que quieres borrar este %{name}? |||| Estas seguro de que quieres borrar estos %{smart_count} elementos?',
      auth_error: 'Error de autenticación',
      bulk_update_content:
        'Estas seguro de que quieres actualizar este %{name}? |||| Estas seguro de que quieres actualizar estos %{smart_count} elementos?',
      bulk_update_title: 'Actualizar %{name} |||| Actualizar %{smart_count} %{name}',
      clear_array_input: 'Estas seguro de que quieres borrar toda la lista?',
      details: 'Detalles',
      error: 'Ha ocurrido un error',
      unsaved_changes: 'Algunos cambios no fueron guardados. ¿Estas seguro que quieres ignorarlos?',
      access_denied: 'Acceso denegado',
      authentication_error: 'Error de autenticación',
      select_all_limit_reached: 'Se ha alcanzado el límite de selección',
    },
    navigation: {
      no_results: 'No se encontraron resultados',
      no_more_results: 'La pagina numero %{page} esta fuera de los limites. Prueba con la pagina anterior.',
      page_out_of_boundaries: 'La pagina numero %{page} se encuentra fuera de los limites',
      page_out_from_end: 'No se puede navegar despues de la ultima pagina',
      page_out_from_begin: 'No se puede navegar antes de la pagina 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
      next: 'Siguiente',
      prev: 'Previo',
      no_filtered_results: 'No hay resultados para el filtro actual',
      clear_filters: 'Limpiar filtros',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} de más de %{total}',
      page_rows_per_page: 'Filas por página:',
      current_page: 'Página %{page}',
      page: 'Ir a la página %{page}',
      first: 'Ir a la primera página',
      last: 'Ir a la última página',
      previous: 'Anterior',
      skip_nav: 'Saltar al contenido',
    },
    auth: {
      username: 'Usuario',
      password: 'Contraseña',
      email: 'Correo electrónico',
      sign_in: 'Loguearse',
      sign_in_error: 'Error de autenticacion, por favor reintenta',
      logout: 'Cerrar sesion',
      auth_check_error: 'Error al verificar la autenticación',
      user_menu: 'Menú de usuario',
    },
    notification: {
      updated: 'Elemento actualizado |||| %{smart_count} elementos actualizados',
      created: 'Elemento creado',
      deleted: 'Elemento borrado |||| %{smart_count} elementos borrados',
      bad_item: 'Elemento incorrecto',
      item_doesnt_exist: 'El elemento no existe',
      http_error: 'Error de comunicacion con el servidor',
      canceled: 'Accion cancelada',
      data_provider_error: 'Error del proveedor de datos',
      i18n_error: 'Error de traducción',
      logged_out: 'Su sesión ha terminado',
      not_authorized: 'No autorizado',
      application_update_available: 'Una nueva versión está disponible',
    },
    validation: {
      required: 'Requerido',
      minLength: 'Debe tener al menos %{min} caracteres',
      maxLength: 'Deber tener %{max} caracteres o menos',
      minValue: 'De ser al menos %{min}',
      maxValue: 'Debe ser %{max} o menos',
      number: 'Debe ser un number',
      email: 'Debe ser un correo electronico valido',
      oneOf: 'Debe ser uno de los siguientes valores: %{options}',
      regex: 'Debe seguir un formato especifico (regexp): %{pattern}',
    },
    sort: {
      sort_by: 'Ordenar por',
      ASC: 'Ascendente',
      DESC: 'Descendente',
    },
    saved_queries: {
      label: 'Consultas guardadas',
      query_name: 'Nombre de la consulta',
      new_label: 'Nueva consulta',
      new_dialog_title: 'Guardar consulta actual como',
      remove_label: 'Eliminar consulta guardada',
      remove_label_with_name: 'Eliminar consulta "%{name}"',
      remove_dialog_title: 'Eliminar consulta guardada',
      remove_message: '¿Está seguro que desea eliminar esta consulta?',
      help: 'Filtrar la lista y guardar esta consulta para más tarde',
    },
    configurable: {
      customize: 'Personalizar',
      configureMode: 'Configurar página',
      inspector: {
        title: 'Inspector',
        content: 'Contenido',
        reset: 'Restablecer',
        hideAll: 'Ocultar todo',
        showAll: 'Mostrar todo',
      },
      Datagrid: {
        title: 'Tabla',
        unlabeled: 'Columna sin etiqueta',
      },
      SimpleForm: {
        title: 'Formulario',
        unlabeled: 'Campo sin etiqueta',
      },
      SimpleList: {
        title: 'Lista',
        primaryText: 'Texto principal',
        secondaryText: 'Texto secundario',
        tertiaryText: 'Texto terciario',
      },
    },
  },
}

export default messages
